import React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IHeadphoneIconProps extends IconPropsType {}

const Headphone2Icon = ({
  size = 24,
  color = '#295E48',
  ...props
}: IHeadphoneIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.63306 12.68V18.3789C7.63306 18.7187 7.90758 18.993 8.24713 18.993C8.58611 18.993 8.86121 18.7187 8.86121 18.3789V12.68C8.86121 12.3409 8.58611 12.0659 8.24713 12.0659C7.90758 12.0659 7.63306 12.3406 7.63306 12.68Z"
      fill={color}
    />
    <path
      d="M5.70563 19H7.05776V12.2339C7.06146 12.2014 7.06737 12.1691 7.06737 12.1358C7.06737 9.21677 9.4235 6.84223 12.3192 6.84223C15.2145 6.84223 17.5706 9.21677 17.5706 12.1358C17.5706 12.1805 17.5772 12.2237 17.5838 12.2669V19H18.9361C19.8773 19 20.641 18.2102 20.641 17.2357V13.7073C20.641 12.9037 20.1205 12.2266 19.4099 12.0136C19.3445 8.13569 16.1899 5 12.3195 5C8.44798 5 5.29295 8.13598 5.22821 12.0151C4.51859 12.2284 4 12.9049 4 13.7078V17.2357C4 18.2096 4.76358 19 5.70563 19Z"
      fill={color}
    />
    <path
      d="M15.7812 12.68V18.3789C15.7812 18.7187 16.0562 18.993 16.3953 18.993C16.7344 18.993 17.0093 18.7187 17.0093 18.3789V12.68C17.0093 12.3409 16.7344 12.0659 16.3953 12.0659C16.0555 12.0659 15.7812 12.3406 15.7812 12.68Z"
      fill={color}
    />
  </svg>
);

export default Headphone2Icon;
